import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type TotalErrorColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const totalErrorColumnConfig = <T extends TableRow>({
  options,
}: TotalErrorColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'totalError',
  label: <Trans i18nKey="total_error" />,
  render: (value: number) => (
    <div className="overflow-hidden text-ellipsis">{value.toFixed(0)}</div>
  ),
  acessorKey: 'totalError',
  sortable: false,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
